//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'DeltaDialog',
  props: {
    config: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      maximized: false,
      // maximizedOnNarrow: Boolean,
      persistent: false,
      noWrap: false,
      // contentWidth: Number, // px
      unCancellable: false,
      dialogClass: null,
      headerLabel: null,
      headerHidden: null,
      contentComponent: null,
      contentProps: null,
      componentHandlers: null,
      onCancel: null
    }
  },
  watch: {
    config: {
      handler: function (config) {
        // Вызывается при создании этого компонента
        this.openDialog(config)
      },
      immediate: true
    }
  },
  methods: {
    openDialog: function (config) {
      let dialogStyle = config.style || ''
      let maximized = !!config.maximized
      if (config.contentWidth) {
        if (!maximized && config.maximizedOnNarrow) {
          const width = window.innerWidth
          if (width < config.contentWidth) {
            maximized = true
          }
        }
        if (!maximized) {
          dialogStyle += `max-width: ${config.contentWidth}px; width: ${config.contentWidth}px;` // TODO проверить наличие другого max-width
        } else {
          // TODO удалить max-width
        }
      }

      this.maximized = maximized
      this.persistent = !!config.persistent
      this.noWrap = !!config.noWrap
      this.unCancellable = !!config.unCancellable
      this.dialogClass = config.class || ''
      this.dialogStyle = dialogStyle
      this.headerLabel = config.headerLabel || ''
      this.headerHidden = config.headerHidden || false
      this.contentComponent = config.contentComponent // TODO required
      this.contentProps = config.contentProps || {}
      this.componentHandlers = config.componentHandlers || {}
      this.onCancel = config.onCancel || (() => {})
      // this.show()
    },

    onEscape: function () {
      if (!this.persistent) {
        this.onCancelDialog()
      }
    },
    onCancelDialog: function () {
      if (!this.unCancellable) {
        this.onCancel()
        this.hide()
      }
    },

    // following methods are REQUIRED ===
    show () {
      // Вызывается в mounted, то есть после watch -> config
      this.$refs.dialog.show()
    },
    hide () {
      this.$refs.dialog.hide()
    },
    // ===

    onDialogHide () {
      this.$emit('hide') // REQUIRED to be emitted, when QDialog emits "hide" event
    },
    onOKClick () {
      this.$emit('ok') // REQUIRED; or with payload: this.$emit('ok', { ... })
      this.hide()
    },
    onCancelClick () {
      this.hide()
    }
  }
}
